import { gql } from '@apollo/client';

export const GET_LOCAL_STATE = gql`
  query LocalState {
    page @client
  }
`;
